@import 'styles/variables';

.modal {
  width: 650px;
}

.body {
  display: flex;
  flex-direction: column;
  gap: 40px;
}

.tabLabel {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.disabled {
  opacity: 0.5;
  pointer-events: none;
  user-select: none;
}

.skeleton {
  display: flex;
  flex-direction: column;
  gap: 40px;
}

.skeletonSection {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.skeletonHeader {
  height: 18px;
  width: 40%;
}

.skeletonInput {
  height: 40px;
  width: 100%;
}
